import React from 'react';
import FeaturePage from './FeaturePage';

function DocumentManagementPage() {
  return (
    <FeaturePage title="Document Management">
      {/* You can add specific content here later */}
    </FeaturePage>
  );
}

export default DocumentManagementPage; 